import { render, staticRenderFns } from "./OrdersSuperiorMenu.vue?vue&type=template&id=62b165e3"
import script from "./OrdersSuperiorMenu.vue?vue&type=script&lang=js"
export * from "./OrdersSuperiorMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports